import { createContext } from 'preact/compat';
export const optionsDefaults = {
    analyticsTitle: 'Quick Pay',
    analyticsUrl: 'https://www.snowdome.co.uk/',
    analyticsPath: '/',
    termsAccepted: true,
    products: [],
    title: undefined,
};
export const OptionsCTX = createContext(optionsDefaults);
